import { Component, OnDestroy } from '@angular/core'
import { FormGroupState } from 'ngrx-forms'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { tap } from 'rxjs/operators'
import { AppState } from '../app.root.state'
import { selectLoginState, LoginFormValues } from './login.state'
import { LoginActions } from './login.actions'

@Component({
  selector: 'cover-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy {
  // sub: Subscription
  // formState$: Observable<FormGroupState<LoginFormValues>>

  constructor(private readonly store: Store<AppState>) {
    // this.formState$ = this.store.select(selectLoginState.loginControls)
    // this.sub = this.formState$
    //   .pipe(
    //     tap(() => {
    //       //  this.logger.debug(res)
    //     }),
    //   )
    //   .subscribe()
  }

  onSubmit(data: LoginFormValues): void {
    // todo: validate form values
    this.store.dispatch(LoginActions.login({ payload: data }))
  }

  ngOnDestroy(): void {
    // this.sub.unsubscribe()
  }
}
